import { useCallback } from 'react';
import FakeSelect from 'components/FakeSelect';
import InlineDropdown from 'components/InlineDropdown';
import { PROVIDERS } from 'consts';
import { useTranslate } from 'lib/tolgee';
import { TOLGEE_GLOBALS } from 'utils';
function GraphSelector({
  provider,
  selectedGraph,
  setSelectedGraph,
  options
}) {
  const t = useTranslate();
  const handleChange = useCallback(graph => setSelectedGraph(graph), [setSelectedGraph]);
  if (provider === PROVIDERS.tw.KEY) {
    return <FakeSelect label={t(TOLGEE_GLOBALS.metrics)} value={t(TOLGEE_GLOBALS.viewers)} />;
  }
  return <InlineDropdown onChange={handleChange} options={options} selected={selectedGraph} label={t(TOLGEE_GLOBALS.metrics)} />;
}
export default GraphSelector;